module.exports = __webpack_public_path__ + "static/graphql-de-icon-3675eef6b5de6001bce66a7486dde775.png";